import { useState, useEffect, useCallback } from 'react';
import { getITTContentsList } from '../components/plugin/pwc/pwcIttApis';

const LIST_COUNT = 30;

function useFetchIttContents(query, page) {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const [contentsList, setContentsList] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  const sendQuery = useCallback(async () => {
    try {
      if (query) {
        await setIsLoading(true);
        await setError(false);
        const option = {
          ...query,
          // searchCondition: 'ALL',
          pageSize: LIST_COUNT,
          searchContentsTyCode: 'MVP',
          // pageUnit: LIST_COUNT,
          pageIndex: page
        };
        const res = await getITTContentsList(option);
        const newItems = res?.data?.data?.result || [];
        const isEnd = LIST_COUNT !== newItems.length;
        await setContentsList((prev) =>
          page === 1 ? newItems : [...new Set([...prev, ...newItems])]
        );
        await setHasMore(!isEnd);
        setIsLoading(false);
      }
    } catch (err) {
      setError(err);
    }
  }, [query, page]);

  useEffect(() => {
    sendQuery(query);
  }, [query, sendQuery, page]);

  return { isLoading, error, contentsList, hasMore };
}

export default useFetchIttContents;
